import { render, staticRenderFns } from "./IconSparklesSolid.vue?vue&type=template&id=56b43a68"
import script from "./IconSparklesSolid.vue?vue&type=script&lang=js"
export * from "./IconSparklesSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports